import React, {Component} from 'react';
import '../css/views/booking-common.css';
import '../css/theme/mainContent.css';
import '../css/theme/forms.css';
import '../css/theme/forms-block.css';
import '../css/theme/buttons.css';
import Error from "./Error";
import DropGallery from "../components/DropGallery";
import RequiredFieldIndicationMessage from './checkin/component/RequiredFieldIndicationMessage';
import {
    generateInitialStateFromCustomCheckinConfiguration,
    validateCustomCheckInConfiguration
} from "./checkin/util/check-in-validation-util";
import OCREnabledField from "./checkin/component/OCREnabledField";
import OCREnabledAssetField from "./checkin/component/OCREnabledAssetField";
import OCREngine from "../util/OCREngineUtil";
import BarCodeScannerEnabledField from "./checkin/component/BarCodeScannerEnabledField";
import {AppContext} from "../context/app-context";
import {removeInitialSpecialChars} from "../util/sanitizeUtil";
import ScacCodeInput from './checkin/component/ScacCodeInput';

class TrailerEmptyCheckInForm extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            errorMessage: '',
            trailerNumber: '',
            driverFirstName: '',
            driverLastName: '',
            driverLicenseNumber: '',
            truckLicensePlateNumber: '',
            notes: '',
            scacCode: '',
            assetSize: '',
            ...generateInitialStateFromCustomCheckinConfiguration(this.props.customFields)
        }
    }

    updateDropzone = dropzone => {
        this.dropzone = dropzone;
    };

    handleFieldChange = event => {
        this.setState({[event.target.name]: removeInitialSpecialChars(event.target.value.toUpperCase())});
    };

    validateDefaultConfig = () => {
        if (!this.props.assetType && !this.props.assetType.value) {
            return "Please select an equipment type."
        }

        if (!this.state.trailerNumber.trim()) {
            return "Please enter a trailer number."
        }

        if (!this.state.driverFirstName.trim()) {
            return "Please enter the driver's first name."
        }

        if (!this.state.driverLastName.trim()) {
            return "Please enter the driver's last name."
        }

        if (!this.state.assetSize.trim()) {
            return "Please enter an asset size."
        }
    }

    readBarcodeResults = (results) => {
        let fields = OCREngine.setDriversLicenseFields(results);
        let firstName = fields.firstName;
        let lastName = fields.lastName;
        let driversLicense = fields.driversLicense;

        this.setState({driverFirstName: firstName, driverLastName: lastName, driverLicenseNumber: driversLicense})
    }

    checkInAsset = () => {

        this.setState({errorMessage: ''});

        let errorMessage

        if (this.props.customFields && this.props.customFields.length > 0) {
            const clonedState = {...this.state}
            errorMessage = validateCustomCheckInConfiguration(clonedState, this.props.customFields)
        } else {
            errorMessage = this.validateDefaultConfig()
        }

        if (errorMessage) {
            this.setState({errorMessage})
            return
        }

        this.props.handleFormSave({
            trailerNumber: this.state.trailerNumber.trim(),
            driverFirstName: this.state.driverFirstName.trim(),
            driverLastName: this.state.driverLastName.trim(),
            driverLicenseNumber: this.state.driverLicenseNumber.trim(),
            truckLicensePlateNumber: this.state.truckLicensePlateNumber.trim(),
            notes: this.state.notes.trim(),
            scacCode: this.state.scacCode.trim(),
            assetSize: this.state.assetSize.trim(),
            assetType: this.props.assetType,
            dropzone: this.dropzone
        });

    };

    render() {

        const {correlationId} = this.props;
        const appContext = this.context;
        const { user } = appContext;

        return (
            <div>
                <OCREnabledAssetField
                    name="assetSize"
                    label="ASSET SIZE"
                    value={this.state.assetSize}
                    onChange={this.handleFieldChange}
                    setText={(text) => this.setState({assetSize: text})}
                    placeholder="Choose"
                    isEnabled={user.rekognitionPrivileges}
                    correlationId={correlationId}
                    required={true}
                />
                <OCREnabledField
                    name="trailerNumber"
                    label="TRAILER NUMBER"
                    value={this.state.trailerNumber}
                    onChange={this.handleFieldChange}
                    setText={(text) => this.setState({trailerNumber: text})}
                    placeholder="Enter the trailer number"
                    isEnabled={user.rekognitionPrivileges}
                    correlationId={correlationId}
                    required={true}
                />
                <BarCodeScannerEnabledField
                    name="driverLicenseNumber"
                    label="DRIVER LICENSE NUMBER"
                    value={this.state.driverLicenseNumber}
                    onChange={this.handleFieldChange}
                    readScannedResults={this.readBarcodeResults}
                    placeholder="Scan the driver's license number"
                    isEnabled={user.rekognitionPrivileges}
                    correlationId={correlationId}
                />
                <OCREnabledField
                    name="driverFirstName"
                    label="DRIVER'S FIRST NAME"
                    value={this.state.driverFirstName}
                    onChange={this.handleFieldChange}
                    setText={(text) => this.setState({driverFirstName: text})}
                    placeholder="Enter the driver's first name"
                    isEnabled={user.rekognitionPrivileges}
                    correlationId={correlationId}
                    required={true}
                />
                <OCREnabledField
                    name="driverLastName"
                    label="DRIVER'S LAST NAME"
                    value={this.state.driverLastName}
                    onChange={this.handleFieldChange}
                    setText={(text) => this.setState({driverLastName: text})}
                    placeholder="Enter the driver's last name"
                    isEnabled={user.rekognitionPrivileges}
                    correlationId={correlationId}
                    required={true}
                />
                <ScacCodeInput
                    scacCode={this.state.scacCode} 
                    setScacCode={(text) => this.setState({scacCode: text})} 
                    handleChange={this.handleFieldChange} 
                    correlationId={correlationId} 
                    isEnabled={user.rekognitionPrivileges}
                />
                <OCREnabledField
                    name="truckLicensePlateNumber"
                    label="TRUCK LICENSE PLATE NUMBER"
                    value={this.state.truckLicensePlateNumber}
                    onChange={this.handleFieldChange}
                    setText={(text) => this.setState({truckLicensePlateNumber: text})}
                    placeholder="Enter the truck's license plate number"
                    isEnabled={user.rekognitionPrivileges}
                    correlationId={correlationId}
                />
                <fieldset className="ss-bottom">
                    <label htmlFor="notes">REMARKS OR NOTES</label>
                    <textarea type="text"
                              id="notes"
                              name="notes"
                              value={this.state.notes}
                              onChange={this.handleFieldChange}
                              placeholder="Enter any notes about the check in."
                    />
                </fieldset>
                <RequiredFieldIndicationMessage/>

                <br/>
                <label>Click below to add images</label>
                <fieldset className="ss-top ss-dz">
                    <DropGallery bucket={this.props.bucket}
                                 updateDropzone={this.updateDropzone}
                    />
                </fieldset>
                {this.state.errorMessage ? <Error>{this.state.errorMessage}</Error> : ''}

                <div className='ss-check-in-button-container'>
                    <button type="button" className="ss-button-primary ss-dialog-button"
                            onClick={() => this.checkInAsset()}>Check In
                    </button>
                    <button type="button" className="ss-button-primary reverse ss-dialog-button"
                            onClick={() => this.props.handlePanelCloseEvent()}>Cancel
                    </button>
                </div>
            </div>
        );
    }
}

export default TrailerEmptyCheckInForm;
